<template>
    <div class='card' v-loading="loading">
        <div class='card-header'>
        <el-row type="flex" justify="center">
            <el-col :span="12">
                <label class='az-content-label' style='text-transform: none'>Contributions
                  <span style="font-size:12px;font-weight:400">{{dateformats.getFinancialYear()}}</span>
                </label>
            </el-col>
            <el-col :span="8">
                <el-input 
                    style="fload:right"
                    size='mini'
                    v-model="message" 
                    prefix-icon="el-icon-search"
                    placeholder="Search">
                </el-input>
            </el-col>
            <el-col :span="4" >
                <span style="float:right">
                  <el-button size="mini" v-on:click="other.exportExcel('Contributions.xlsx')">Excel</el-button>
                  <el-button size="mini" v-on:click="generateReport">PDF</el-button>
                </span>
            </el-col>
        </el-row>
        </div>
        <div class='card-body' >
                <el-table
                :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                stripe
                size="small"
                style="width: 100%;font-size:13px"
                :default-sort = "{prop: 'Fund Name', order: 'ascending'}"
                >
                <el-table-column
                prop="Fund Name,Fund Code"
                label="Fund Name"
                sortable
                style='font-weight:500'
                >
                <template slot-scope="scope" >
                    <div style='font-weight:500'>
                      <router-link :to="{path:'/funddashboard/'+scope.row['Fund Code'],query:{name:scope.row['Fund Name']}}">
                        {{isSample?'Sample Family Super Fund '+(index+1):scope.row['Fund Name']}} 
                      </router-link>
                    </div>
                </template>
                </el-table-column>
                <el-table-column
                prop="Member"
                label="Member"
                sortable
                >
                </el-table-column>
                <el-table-column
                prop="Concessional conribution % towards cap"
                label="Concessional conribution % towards cap"
                sortable
                >
                </el-table-column>
                <el-table-column
                prop="Non Concessional conribution % towards cap"
                label="Non Concessional conribution % towards cap"
                sortable
                >
                </el-table-column>
            </el-table>
            <div style="text-align: center;margin-top: 60px;">
            <el-pagination
                :current-page="currentPage"
                :page-size="pagesize"
                layout="total, prev, pager, next, jumper"
                :total="total"
                @current-change="current_change">
            </el-pagination>
            </div>
          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="1400"
            filename="Contributions"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="90%"
    
            @hasStartedGeneration="hasStartedGeneration()"
            @hasGenerated="hasGenerated($event)"
            ref="html2Pdf"
        >
        <section slot="pdf-content">
            <table id="table" class="table">
              <thead>
                <tr>
                  <th class="wd-25p">Fund Name</th>
                  <th class="wd-25p">Member</th>
                  <th>Concessional conribution % towards cap</th>
                  <th>Non Concessional conribution % towards cap</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(con,index) in contributions" :key="con['Fund Code']" v-show="con['Fund Name'].toLowerCase().match(message.toLowerCase())">
                  <td style='font-weight:500'><router-link :to="{path:'/funddashboard/'+con['Fund Code'],query:{name:con['Fund Name']}}">{{isSample?'Sample Family Super Fund '+(index+1):con['Fund Name']}} </router-link></td>
                  <td>{{isSample?'Mr Mike Sample '+(index+1):con['Member']}}</td>
                  <td>{{con['Concessional conribution % towards cap']}}</td>
                  <td>{{con['Non Concessional conribution % towards cap']}}</td>
                </tr>
              </tbody>
            </table>
        </section>
        </vue-html2pdf>
        <DisclaimerV2>
          <div style="font-size:12px;max-width:600px">
            The contribution cap figures shown are based on last SMSF annual return lodged and other information available to us.  For accuracy, you will need to review the Member’s MyGov account and super contributions made to any fund up to date.
          </div>
        </DisclaimerV2>
        </div>
    </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import other from '../../../utils/other'
import dateformats from '../../../utils/dateformats'
export default {
    name:'contributions',
    components: { 
      VueHtml2pdf,
      DisclaimerV2: () => import('@/views/adviserpanel/elements/DisclaimerV2.vue'),
    },
    data(){
        return{
            isSample:false,
            message:'',
            contributions:[],
            loading:true,
            total: 0,
            pagesize:15,
            currentPage:1,
            other:other,
            dateformats:dateformats,
        }
    },
    computed:{
      tableData:function(){
        var message=this.message;
        if(message){
          return  this.contributions.filter(function(dataNews){
            return Object.keys(dataNews).some(function(key){
              return String(dataNews[key]).toLowerCase().indexOf(message) > -1
            })
          })
        }
        return this.contributions
      }
    },
    created(){
        this.getContributionsData();
    },
    methods:{
        getContributionsData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.isSample = userdetail['sample'];
            let brand = localStorage.getItem('brand_code')
            this.$api.adviserdashboard_api.contributions(brand).then(response =>{
                this.contributions = response.data['contributions']
                this.total=this.contributions.length
                this.loading=false;
            });
        
        },
        current_change:function(currentPage){
            this.currentPage = currentPage;
        },
        generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
    }
}
</script>
<style scoped>
.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #cdd4e0;
}

</style>